// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAWO6ybfXM-XZFpAGSsIdzdzedjiR_dFRc",
  authDomain: "mcommerce-4f9eb.firebaseapp.com",
  databaseURL: "https://mcommerce-4f9eb-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "mcommerce-4f9eb",
  storageBucket: "mcommerce-4f9eb.firebasestorage.app",
  messagingSenderId: "880179721374",
  appId: "1:880179721374:web:759c73028182bd1655778f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getDatabase(app);
export default app;